// South African seasonal theme helpers.
// Pure module-level functions — no React hooks here so this can be safely
// imported anywhere without violating Rules of Hooks.

export const SEASONS = ["spring", "summer", "autumn", "winter"];

/**
 * Returns the current South African meteorological season for the given date.
 *   Spring : September – November (months 9, 10, 11)
 *   Summer : December – February  (months 12, 1, 2)
 *   Autumn : March – May          (months 3, 4, 5)
 *   Winter : June – August        (months 6, 7, 8)
 * @param {Date} [date] - Optional date; defaults to "now".
 * @returns {"spring"|"summer"|"autumn"|"winter"}
 */
export function getSouthAfricanSeason(date) {
  const d = date instanceof Date ? date : new Date();
  const month = d.getMonth() + 1; // 1..12
  if (month >= 9 && month <= 11) return "spring";
  if (month === 12 || month <= 2) return "summer";
  if (month >= 3 && month <= 5) return "autumn";
  return "winter";
}

/**
 * Human-readable label for a season key.
 */
export function getSeasonLabel(season) {
  switch (season) {
    case "spring":
      return "Spring";
    case "summer":
      return "Summer";
    case "autumn":
      return "Autumn";
    case "winter":
      return "Winter";
    default:
      return "";
  }
}
